import { Application, ApplicationStatus } from '@features/applications';
import {
  lightPurple,
  primaryBlue,
  primaryGrey,
  primaryRed,
  primaryGreen,
  successGreen,
  primaryPurple,
  yellow,
  darkBlue,
} from '@styles/colors';
import dayjs from 'dayjs';

export const getStatusChipColor = (
  status: ApplicationStatus,
  application?: Application,
) => {
  switch (status.toLowerCase()) {
    case 'withdraw application':
      return primaryGrey;
    case 'job offer decline':
      return primaryRed;
    case 'job offer':
      return lightPurple;
    case 'archived':
    case 'resigned':
      return primaryGrey;
    case 'unattended':
      if (application?.hire_flix_interview?.interview_response_url)
        return primaryGreen;
      return yellow;
    case 'messaged':
      return primaryBlue;
    case 'saved':
      return primaryGreen;
    case 'interview process':
      if (application?.hire_flix_interview?.interview_response_url)
        return primaryGreen;
      return darkBlue;
    case 'pending job offers':
      return lightPurple;
    case 'hired':
      return primaryPurple;
    case 'declined':
    case 'terminated':
      return primaryRed;

    case 'attended':
      return successGreen;
    default:
      return yellow;
  }
};

export const getStatusChipLabel = (
  status: ApplicationStatus,
  application: Application,
) => {
  if (application.withdrawn) {
    return 'withdrawn';
  }

  if (application.employer_archive) {
    return 'archived';
  }

  switch (status.toLowerCase()) {
    case 'hired':
      if (application.application_actions.hired_action === 1) {
        return 'terminated';
      }
      if (application.application_actions.hired_action === 2) {
        return 'resigned';
      }
      if (
        import.meta.env.VITE_AUTOMATION_ACCESS_ENTERPRISE_IDS.includes(
          application.job_listing.company.enterprise_company?.id,
        )
      ) {
        // @ts-ignore
        if (application.application_actions.is_taggr_sent === 1) {
          return 'Onboarding Pending';
        }
      }
      return 'HIRED';
    case 'interview process':
    case 'unattended':
      if (
        application.interview_requested &&
        !application.interview_accepted &&
        application?.calendar_item &&
        dayjs(application.calendar_item?.dt_start_time).isBefore(dayjs())
      ) {
        return 'interview no response';
      }
      if (application.interview_action === 'completed') {
        return 'interview completed';
      }
      if (application.interview_action === 'missed') {
        return 'interview missed';
      }
      if (application.interview_requested && !application.interview_accepted) {
        return 'interview requested';
      }
      if (application.interview_declined) {
        return 'interview declined';
      }
      if (application.interview_accepted) {
        return 'interview confirmed';
      }
      if (application.interview_deleted) {
        return 'interview removed';
      }
      if (
        application?.hire_flix_interview &&
        !application?.hire_flix_interview?.interview_response_url
      ) {
        return 'hireflix interview requested';
      }
      if (application?.hire_flix_interview?.interview_response_url) {
        return 'hireflix interview submitted';
      }

    default:
      if (
        ['saved', 'declined'].includes(status.toLowerCase()) &&
        application.interview_action
      ) {
        return `${status} - interview ${application.interview_action}`;
      }

      return status;
  }
};

export const checkInterviewInviteType = (interview_slots: boolean) => {
  if (interview_slots) {
    return 'interview blocks';
  }
  return 'open interviews';
};
